import React from 'react'

import LineLinkContainer from 'src/containers/Auth/LineLink'

const LineLinkPage: React.FC = () => {
  return <LineLinkContainer />
}

export const PATH = '/line-link' as const
export default LineLinkPage
